export default () => ({
  loadingClinics: false,
  clinics: [],
  unity: null,
  chatMessageSettings: null,
  loadingChatMessageSettings: false
})
